export const CUTOFF_TIMES = {
  '11:59:59': 'noon'
}
